/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

export enum AvailableActions {
    EDIT = 'EDIT',
    SUBMIT = 'SUBMIT',
    REPLICATE = 'REPLICATE'
}
